import { useState } from 'react';
import { Iconify } from '@classroom-ai/ui/components/iconify';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { useActiveClass } from 'src/class/class-provider';

import { SchoolYearMenu } from './school-year-menu';

// ----------------------------------------------------------------------

/** The account drawer's school / year block (epic #617) — the other way to change year. */
export function AccountSchoolYear() {
  const { schoolYearOptions, activeSchoolYearId } = useActiveClass();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const active = schoolYearOptions.find((o) => o.yearId === activeSchoolYearId) ?? null;
  if (!active) return null;

  return (
    <Box sx={{ mx: 2.5, mt: 3, mb: 2, p: 1.5, borderRadius: 1.5, bgcolor: 'background.neutral', display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Iconify icon="solar:home-angle-bold-duotone" width={22} sx={{ color: 'text.secondary', flexShrink: 0 }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="subtitle2" noWrap>
          {active.schoolName}
        </Typography>
        <Typography variant="caption" color="text.secondary" noWrap component="div">
          {active.yearName}
          {active.status === 'ACTIVE' ? ' · current year' : ''}
        </Typography>
      </Box>
      {schoolYearOptions.length > 1 && (
        <Button size="small" onClick={(e) => setAnchor(e.currentTarget)}>
          Change
        </Button>
      )}
      <SchoolYearMenu anchorEl={anchor} onClose={() => setAnchor(null)} />
    </Box>
  );
}
